"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORM_CONTROL_SIZES = exports.MASKS = void 0;
exports.MASKS = {
    licensePlate: [/[A-Z]/, /[A-Z]/, /[A-Z]/, '-', /[0-9A-Z]/, /[0-9]/, /[0-9]/, /[0-9]/],
    licensePlate2: [/[A-Z]/, /[A-Z]/, /[A-Z]/, /[0-9A-Z]/, /[0-9]/, /[0-9]/, /[0-9]/],
    cpf: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
    date: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    cellphone: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
};
exports.FORM_CONTROL_SIZES = {
    small: 'small',
    medium: 'medium',
    large: 'large',
};
//# sourceMappingURL=constants.js.map